import { render, staticRenderFns, recyclableRender, components } from "./firstPage.vue?vue&type=template&id=1ee7e597&"
var renderjs
import script from "./firstPage.vue?vue&type=script&lang=js&"
export * from "./firstPage.vue?vue&type=script&lang=js&"
import style0 from "./firstPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/tabBar/firstPage/firstPage.vue"
export default component.exports